import { render, staticRenderFns } from "./discount-modal.vue?vue&type=template&id=afaae578"
import script from "./discount-modal.vue?vue&type=script&lang=js"
export * from "./discount-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports